import { twitterSharing, googlePlusSharing } from '../utils/sharing';

export default class StaticArticle {
  constructor() {
    twitterSharing();
    googlePlusSharing();
  }
}
